<template>
  <div v-if="rentalUnit.areaM2 || rentalUnit.maxCapacity">
    <ion-row class="ion-justify-content-between ion-align-items-center price-subtitle nowrap">
      <div v-if="rentalUnit.areaM2">
        <h3 class="font-sm bold-medium grey">{{ t('announcement.totalArea') }}</h3>
        <ion-row class="ion-justify-content-start ion-align-items-center price-subtitle nowrap">
          <ion-icon :icon="businessOutline" class="medium-icon" color="grey"></ion-icon>
          <p class="padding-list-item">{{ rentalUnit.areaM2 }} m2</p>
        </ion-row>
      </div>

      <div v-if="rentalUnit.maxCapacity" class="padding-list-item">
        <h3 class="font-md bold-medium grey">{{ t('announcement.maxCap') }}</h3>
        <ion-row class="ion-justify-content-start ion-align-items-center price-subtitle nowrap">
          <ion-icon :icon="peopleOutline" class="medium-icon" color="grey"></ion-icon>
          <p class="padding-list-item">
            {{ rentalUnit.maxCapacity }} {{ t('announcement.people') }}
          </p>
        </ion-row>
      </div>
    </ion-row>
  </div>
</template>

<script setup lang="ts">
  import { RentalUnit } from '@/interfaces/elastic/elastic.interface';
  import { IonRow, IonIcon } from '@ionic/vue';
  import { peopleOutline, businessOutline } from 'ionicons/icons';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  withDefaults(
    defineProps<{
      rentalUnit: RentalUnit;
    }>(),
    {},
  );
</script>

<style lang="css" scoped></style>
